'use client';
import styled from 'styled-components';

export const DescriptionList = styled.dl`
  display: grid;
  grid-template-columns: 3fr 2fr;
`;

export const DescriptionListLabel = styled.dt`
  ${props => props.theme.typography.body}
  color: ${props =>
    props.theme.colors.get(props.color, props.theme.colors.text.secondary)};
`;

export const DescriptionListValue = styled.dd`
  ${props => props.theme.typography.body}
  color: ${props =>
    props.theme.colors.get(props.color, props.theme.colors.text.secondary)};
  text-align: right;
`;
